import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from './analytics';
import { bootstrapConsent } from './consentStore';

/**
 * Starts analytics and records a page view per route.
 *
 * A single-page app loads the document once, so gtag.js would otherwise attribute every
 * visit to whichever route the visitor happened to land on. Automatic page views are
 * disabled in `initAnalytics` and sent from here instead.
 *
 * The title is read after the effect runs rather than passed in, because
 * `useDocumentMeta` sets `document.title` in its own effect on the page component -
 * which is a child, and therefore has already run by the time this fires.
 */
export function useAnalytics(): void {
  useEffect(() => {
    bootstrapConsent();
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname, document.title);
  }, [pathname]);
}
